import { Invoice } from '../../Invoices.types';
import { InvoiceDetailsContent } from '../InvoiceDetailsContent';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

interface InvoiceDetailsBottomSheetProps {
  invoice: Invoice | null;
  onClose: () => void;
  onPay: () => void;
}

export function InvoiceDetailsBottomSheet({
  invoice,
  onClose,
  onPay,
}: InvoiceDetailsBottomSheetProps) {
  return (
    <BottomSheet
      isOpen={!!invoice}
      close={onClose}
      onCloseClick={onClose}
      isPageLocked
      isInPortal
      hasHeadBorder={false}
    >
      {invoice ? (
        <InvoiceDetailsContent
          invoice={invoice}
          onClose={onClose}
          onPay={onPay}
        />
      ) : null}
    </BottomSheet>
  );
}
